export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
>
  <g
    transform="matrix(0.79646021,-0.79646021,0.79646021,0.79646021,-5.3362832,9.0000003)"
  >
    <rect
      width="4.599999"
      height="18"
      x="6.7000003"
      y="-5e-07"
    />
    <rect
      width="17.999996"
      height="4.5999999"
      x="5e-07"
      y="6.6999998"
    />
  </g>
</svg>`;
